<forge-card class="no-padding">
    <forge-scaffold>
        <forge-toolbar slot="header">
            @if(!isKeyboardMoveMode) {
            <h2 class="forge-typography--heading2">{{title}}</h2>
            }
            @if(isKeyboardMoveMode) {
            <forge-inline-message>Move mode: ↑ ↓ navigate | ← → expand/collapse | Space drop | Esc cancel</forge-inline-message>
            }
            <div slot="end">
                @if (selectType === CASCADING) {
                <forge-icon-button (click)="selectAll(true)">
                    <forge-tooltip type="label" placement="bottom">Select all</forge-tooltip>
                    <forge-icon name="checkbox_multiple_marked"></forge-icon>
                </forge-icon-button>
                } @if (selectType === CASCADING) {
                <forge-icon-button (click)="selectAll(false)">
                    <forge-tooltip type="label" placement="bottom">Deselect all</forge-tooltip>
                    <forge-icon name="checkbox_multiple_blank_outline"></forge-icon>
                </forge-icon-button>
                }
                <forge-icon-button (click)="expandAll(true)">
                    <forge-tooltip type="label" placement="bottom">Expand all</forge-tooltip>
                    <forge-icon name="expand"></forge-icon>
                </forge-icon-button>

                <forge-icon-button (click)="expandAll(false)">
                    <forge-tooltip type="label" placement="bottom">Collapse all</forge-tooltip>
                    <forge-icon name="arrow_collapse_vertical"></forge-icon>
                </forge-icon-button>
            </div>
        </forge-toolbar>
        <div slot="body" class="tree-view--body">
            @if(treeProgress()) {
            <forge-linear-progress aria-label="tree progress indicator"></forge-linear-progress> 
            }
            <div class="sr-only" role="status" aria-live="polite" aria-atomic="true">
                {{screenReaderAnnouncement}}
            </div>
            <forge-tree
                [mode]="treeMode"
                #forgeTree (forge-tree-item-select)="nodeSelection($event)"
            >
                @for (node of nodes; track node.Id) {
                    <ng-container *ngTemplateOutlet="forgeTreeItem; context: { $implicit: node }"></ng-container>
                }
            </forge-tree>

            <ng-template #forgeTreeItem let-node>
                <forge-tree-item
                    [value]="node.Id"
                    [selected]="disableCascadingSelection ? false : node.Selected"
                    [disabled]="node.Disabled"
                    [open]="node.Expanded"
                    [attr.data-node-id]="node.Id"
                    [attr.tabindex]="0"
                    [attr.aria-checked]="independentSelection ? !!node.Selected : null"
                    (click)="nodeClicked($event, node)"
                    (keydown)="onKeyDown($event, node)"
                    (dragover)="onDragOver($event, node)"
                    (drop)="onDrop($event, node)"
                    (dragleave)="onDragLeave($event)"
                    (forge-tree-item-open)="treeItemToggle($event, node, true)"
                    (forge-tree-item-close)="treeItemToggle($event, node, false)"
                >
                    <div slot="start" fxLayout="row" fxLayoutAlign="start center">
                        @if (independentSelection) {
                        <forge-icon
                            [name]="node.Selected ? 'check_box' : 'check_box_outline_blank'"
                            [style.--forge-icon-color]="node.Selected ? 'var(--forge-theme-tertiary)' : 'var(--forge-theme-text-low)'"
                            [style.opacity]="node.Disabled ? 0.38 : 1"
                            aria-hidden="true"
                            style="margin-right: .5rem;"
                        ></forge-icon>
                        }
                        @if(node.Icon) {
                        <forge-icon [name]="node.Icon" style="--forge-icon-color: var(--forge-theme-text-medium); margin-right: .5rem;"></forge-icon>
                        }
                        <div>{{node.Display}}</div>
                    </div>
                    @if(!disableDragAndDrop) {
                    <div
                        slot="end"
                        fxLayout="row"
                        fxLayoutAlign="end center"
                        draggable="true"
                        (dragstart)="onDragStart($event, node)"
                        (dragend)="onDragEnd($event)"
                        style="cursor: grab;"
                    >
                        <forge-icon name="drag_indicator" style="--forge-icon-color: var(--forge-theme-text-low); font-size: 1rem;"></forge-icon>
                        <forge-tooltip position="bottom">Drag to reorder or press Space to move with keyboard</forge-tooltip>
                    </div>
                    }

                    @if (node.Children && node.Children.length > 0) {
                        @for (child of node.Children; track child.Id) {
                            <ng-container *ngTemplateOutlet="forgeTreeItem; context: { $implicit: child }"></ng-container>
                        }
                    }
                </forge-tree-item>
            </ng-template>
        </div>
    </forge-scaffold>
</forge-card>